import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ColumnVisibilityState {
	/** Colunas ocultas por tabela. Guarda as ocultas (não as visíveis) para colunas novas aparecerem por padrão. */
	hiddenColumns: Record<string, string[]>
	toggleColumn: (tableId: string, key: string, allKeys: string[]) => void
	resetColumns: (tableId: string) => void
}

export const useColumnVisibilityStore = create<ColumnVisibilityState>()(
	persist(
		(set) => ({
			hiddenColumns: {},
			toggleColumn: (tableId, key, allKeys) =>
				set((state) => {
					const hidden = state.hiddenColumns[tableId] ?? []

					if (hidden.includes(key)) {
						return {
							hiddenColumns: {
								...state.hiddenColumns,
								[tableId]: hidden.filter((item) => item !== key),
							},
						}
					}

					// nunca deixa a tabela sem nenhuma coluna
					const visibleCount = allKeys.filter((k) => !hidden.includes(k)).length
					if (visibleCount <= 1) return state

					return {
						hiddenColumns: {
							...state.hiddenColumns,
							[tableId]: [...hidden, key],
						},
					}
				}),
			resetColumns: (tableId) =>
				set((state) => ({
					hiddenColumns: { ...state.hiddenColumns, [tableId]: [] },
				})),
		}),
		{ name: 'ssma-column-visibility' },
	),
)
